import { Cache } from "@siteimprove/alfa-cache";
import { Color } from "@siteimprove/alfa-css";
import { Element, Node, Text } from "@siteimprove/alfa-dom";
import { Refinement } from "@siteimprove/alfa-refinement";
import { Context } from "@siteimprove/alfa-selector";
import { hasComputedStyle } from "../../element/predicate/has-computed-style.js";
const { isElement } = Element;
const { isText } = Text;
const { or, and, test } = Refinement;
const cache = Cache.empty();
function isNotOpaque(device, context) {
    return hasComputedStyle("opacity", (opacity) => opacity.value === 0, device, context);
}
function hasTransparentTextColor(device, context) {
    return hasComputedStyle("color", Color.isTransparent, device, context);
}
/**
 * @internal
 */
export function isTransparent(device, context = Context.empty()) {
    return function isTransparent(node) {
        return cache
            .get(device, Cache.empty)
            .get(context, Cache.empty)
            .get(node, () => test(or(and(isElement, isNotOpaque(device, context)), and(isText, hasTransparentTextColor(device, context)), (node) => node.parent(Node.flatTree).some(isTransparent)), node));
    };
}
//# sourceMappingURL=is-transparent.js.map